"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("phaser");
require("howler");
var Game_1 = require("./Game");
var GameConstants_1 = require("./GameConstants");
var BootScene_1 = require("./scenes/BootScene");
var PreloadScene_1 = require("./scenes/PreloadScene");
var BoardScene_1 = require("./scenes/board-scene/BoardScene");
var GameVars_1 = require("./GameVars");
var GameManager_1 = require("./GameManager");
var ShockWave_1 = require("./plugins/shockwave/ShockWave");
var game;
window.onload = function () {
    GameManager_1.GameManager.setViewPort();
    var gameConfig = {
        version: GameConstants_1.GameConstants.VERSION,
        type: Phaser.AUTO,
        backgroundColor: "000000",
        scale: {
            mode: Phaser.Scale.FIT,
            autoCenter: Phaser.Scale.CENTER_BOTH,
            parent: "content",
            width: GameVars_1.GameVars.gameWidth,
            height: GameVars_1.GameVars.gameHeight
        },
        plugins: {
            scene: [
                { key: "shockwavePlugin", plugin: ShockWave_1.ShockwavePlugin, mapping: "shockwavePlugin" }
            ]
        },
        scene: [
            BootScene_1.BootScene,
            PreloadScene_1.PreloadScene,
            BoardScene_1.BoardScene
        ]
    };
    // If compilation error here, compare Phaser definitions file of working copy (phaser.d.ts, line 48040 on 27-05-2019)
    // Also make sure to delete all *.ts files in node_modules/trailz folder
    game = new Game_1.Game(gameConfig);
    window.focus();
    resize();
    window.addEventListener("resize", resize, false);
    window.addEventListener("orientationchange", onOrientationChange, false);
};
function resize() {
    var canvas = document.querySelector("canvas");
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;
    var windowRatio = windowWidth / windowHeight;
    var gameWidth = game.config.width;
    var gameHeight = game.config.height;
    var gameRatio = gameWidth / gameHeight;
    if (windowRatio < gameRatio) {
        canvas.style.width = windowWidth + "px";
        canvas.style.height = (windowWidth / gameRatio) + "px";
    }
    else {
        canvas.style.width = (windowHeight * gameRatio) + "px";
        canvas.style.height = windowHeight + "px";
    }
}
function onOrientationChange() {
    setTimeout(function () {
        var w = window.innerWidth;
        var h = window.innerHeight;
        var isPortrait = w < h;
        if (isPortrait) {
            if (BootScene_1.BootScene.bootedInWrongOrientation) {
                GameVars_1.GameVars.aspectRatio = window.innerHeight / window.innerWidth;
                GameVars_1.GameVars.scaleY = (GameVars_1.GameVars.gameHeight / GameVars_1.GameVars.gameWidth) / GameVars_1.GameVars.aspectRatio;
                BootScene_1.BootScene.bootedInWrongOrientation = false;
                GameManager_1.GameManager.init();
            }
            document.getElementById("orientation").style.display = "none";
            document.getElementById("content").style.display = "block";
        }
        else {
            document.getElementById("orientation").style.display = "block";
            document.getElementById("content").style.display = "none";
        }
    }, 250);
}
